import createSelector from "../../utils/reselect";

const budgetsStateData = (state) => {
  const { budgets } = state;
  return budgets || {};
};

export const getError = createSelector(budgetsStateData, (budgets) =>
  budgets.get("error")
);

export const budgetPagination = createSelector(budgetsStateData, (budgets) =>
  budgets.get("budgetPagination")
);

export const budgets = createSelector(budgetsStateData, (budgets) =>
  budgets.get("budgets")
);

export const budgetLoading = createSelector(budgetsStateData, (budgets) =>
  budgets.get("budgetLoading")
);

export const budgetsLoading = createSelector(budgetsStateData, (budgets) =>
  budgets.get("pageLoading")
);
